const initialState = {
  IsFetchData: true,

  top10FileAlerts: [],
  top10HostAlerts: [],
  top10NetworkAlerts: [],
  top10UserAlerts: [],

  countTotalAlerts: 0,
  countHighAlerts: 0,
  countMedAlerts: 0,
  countLowAlerts: 0,
  countOpendAlerts: 0,
  countClosedAlerts: 0,

  fileAlertsCount: 0,
  userAlertsCount: 0,
  hostAlertsCount: 0,
  networkAlertsCount: 0,

  alerts: [],

  startDate: '',
  endDate: '',

  lowAlerts: [],
  medAlerts: [],
  highAlerts: [],
  allAlerts: [],

  AlertsCountByDate: [],
  isSpinner: false,

  preserntDataStatus: false,

  reports: [],
  ssoToken: '',
  baseUrl: ''
};

export default initialState;
